import { createFileRoute } from '@tanstack/react-router'

import { AuthForgotPasswordPage } from '@/features/auth/pages'
import { AuthModes } from '@/features/auth/policy'
import { useTenantOptional } from '@/shared/contexts/TenantContext'

export const Route = createFileRoute('/_event/auth/forgot-password')({
  staticData: {
    auth: {
      mode: AuthModes.BOOTSTRAP,
      requiresDigitalProductId: false
    }
  },
  component: TenantAuthForgotPasswordRoute
})

function TenantAuthForgotPasswordRoute() {
  const tenant = useTenantOptional()

  return (
    <AuthForgotPasswordPage
      digitalProductId={tenant?.digitalProductId ?? undefined}
    />
  )
}
